<template>
<div class="defaultIndex">
    <vcontent />  
</div>
</template>
<script>

import vcontent from './index_content'
export default {
    components: {
        vcontent,
    }
}
    
</script>

<style lang="stylus" scoped>
@import "~styl/mixin.styl"


</style>



// WEBPACK FOOTER //
// src/components/index/defaultIndex.vue